module.exports = __webpack_public_path__ + "img/ledger-observer.618975f7.gif";